export const icons = {
  get (name, css_classes) {
    let obj = this.icons[name]
    if (obj) {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + obj.viewbox + '" class="svg ' + css_classes + '">' + obj.path + '</svg>'
    } else {
      return '<!-- !load icon ' + name + ' -->'
    }
  },
  icons: {
    caret_down: {
      viewbox: '0 0 24 24',
      path: '<path d="M6.1018 8C5.02785 8 4.45387 9.2649 5.16108 10.0731L10.6829 16.3838C11.3801 17.1806 12.6197 17.1806 13.3169 16.3838L18.8388 10.0731C19.5459 9.2649 18.972 8 17.898 8H6.1018Z"/>'
    },
    filter_x: {
      viewbox: '0 0 576 512',
      path: '<path d="M0 41.7C0 18.7 18.7 0 41.7 0H469.9C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48H55L218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2v68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3V272.5L9.4 68C3.3 60.6 0 51.3 0 41.7zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"/>'
    },
    line: {
      viewbox: '0 0 640 512',
      path: '<path d="M640 247.5v17a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-17a16 16 0 0 1 16-16h608a16 16 0 0 1 16 16z"/>'
    },
    map: {
      viewbox: '0 0 576 512',
      path: '<path d="M160 387.8L32 434.3V118.4L160 71.9V387.8zm224 54.4L192 387.3V69.9l192 54.9V442.1zm32-2V124.2L544 77.7V393.6L416 440.1zM0 480l32-11.6L176 416l224 64 176-64V66 32L544 43.6 400 96 176 32 0 96V445.9 480z"/>'
    },
    circle: {
      viewbox: '0 0 512 512',
      path: '<path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>'
    },
    circle_arrow_left: {
      viewbox: '0 0 512 512',
      path: '<path d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM119 239L231 127l17-17L281.9 144l-17 17-71 71L376 232l24 0 0 48-24 0-182.1 0 71 71 17 17L248 401.9l-17-17L119 273l-17-17 17-17z"/>'
    },
    circle_check: {
      viewbox: '0 0 512 512',
      path: '<path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/>'
    }
  }
}
